import React from 'react';
import { Link } from 'react-router-dom';

import classes from './MenuItems.module.css';
import RouteEndPoints from '../../utilities/RouteEndPoints';
import { GetFromLocalStorage } from '../../utilities/CommonMethods';
import Constants from '../../utilities/Constants';

const menuItems = (props) => {

    let styleClasses = [classes.MenuItemList];
    let profileDropdown = false;

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }

        if (props.styleclass.indexOf('ProfileDropdown') > -1) {
            styleClasses.push(classes.ProfileDropdown);
            profileDropdown = true;
        }
    }

    const menuClicked = (logOut) => {
        if (logOut) { props.logoutClicked() }
        props.clicked()
    }

    const showMDStudentPopup = () => {
        props.clicked();
        props.showMDStudentPopup();
    }

    const isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

    return (
        <div className={styleClasses.join(' ')}>
            {
                !profileDropdown ? null :
                    <>
                        <Link className={classes.MenuLink} onClick={() => menuClicked(false)} to={RouteEndPoints.EDIT_PROFILE + '/' + GetFromLocalStorage(Constants.KEY_USERNAME)}>
                            <div className={classes.MenuItem}>Profile</div>
                        </Link>

                        {
                            isLearner
                                ? <Link className={classes.MenuLink} onClick={() => menuClicked(false)} to={RouteEndPoints.CERTIFICATION_PAGE}>
                                    <div className={classes.MenuItem}>Certification</div>
                                </Link>
                                : null
                        }

                        {
                            isLearner
                                ? props.programType !== 'micro_degree'
                                    // ? <Link className={classes.MenuLink} onClick={() => menuClicked(false)} to={RouteEndPoints.UPDATE_JOB_PROFILE}>
                                    //     <div className={classes.MenuItem}>Update Job Profile</div>
                                    // </Link>
                                    ? <a className={classes.MenuLink} onClick={() => menuClicked(false)} href='https://forms.gle/wooxXUFL1BmwUCtq5' target='_blank' rel='noreferrer noopener'>
                                        <div className={classes.MenuItem}>Update Job Profile</div>
                                    </a>
                                    : <div className={classes.MenuLink} onClick={showMDStudentPopup}>
                                        <div className={classes.MenuItem}>Update Job Profile</div>
                                    </div>
                                : null
                        }

                        {
                            isLearner
                                ? <Link className={classes.MenuLink} onClick={() => menuClicked(false)} to={RouteEndPoints.PLACEMENTS}>
                                    <div className={classes.MenuItem}>{props.programType === 'micro_degree' ? 'Jobs' : 'Placements'}</div>
                                </Link>
                                : null
                        }

                        <Link className={classes.MenuLink} onClick={() => menuClicked(false)} to={RouteEndPoints.CHANGE_PASSWORD_PAGE}>
                            <div className={classes.MenuItem}>Change Password</div>
                        </Link>

                        <div className={classes.MenuItem} onClick={() => menuClicked(true)}>Log Out</div>
                    </>
            }
        </div>
    )
}

export default menuItems;